export default __webpack_public_path__ + "static/media/frame_beige_new.b33d2741.png";